import AdListItem from "Components/Ad/AdListItem";
import HeaderPageTitle from "Components/Base/HeaderPageTitle";
import { Categories } from "Components/Filters/Categories";
import { Subcategories } from "Components/Filters/Subcategories";
import { IOptions } from "Components/Form/Inputs/CheckboxSearch";
import Cities, { ICity } from "Components/Form/Inputs/Cities";
import RangeField from "Components/Form/Inputs/RangeField";
import States, { IState } from "Components/Form/Inputs/States";
import List2 from "Components/List2";
import Sorting, { TSortingValue } from "Components/Sorting";
import arrayToString from "Helpers/arrayToString";
import stringRange from "Helpers/stringRange";
import useCategories from "Hooks/Categories/useCategories";
import useSubCategories from "Hooks/Categories/useSubcategories";
import { useProducts } from "Hooks/Products/useProducts";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Routes from "Routes";
import { TRange } from "Services/pagination";
import FilterByLetter from "Views/Stores/List/FilterByLetter";
import * as Styledd from "../../../Components/Filters2/styles";
import * as Styled from "./styles";
import { useSelector } from "react-redux";
import { ReducerState } from "Redux/store";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

interface Props {
  row?: number;
  perPage?: number;
  hideSearch?: boolean;
  hidePagination?: boolean;
  hideFilters?: boolean;
  hideSorting?: boolean;
  inline?: boolean;
  userId?: number;
  published?: boolean;
  title?: string;
  link?: string;
}

const ProductList: React.FC<Props> = ({
  row,
  perPage,
  hideSearch = false,
  hideFilters = false,
  hidePagination = false,
  hideSorting = false,
  inline = false,
  userId,
  published = true,
  title,
  link = "",
}) => {
  const { mobile } = useSelector((state: ReducerState) => state.locale);
  const [hideStates, setHideStates] = useState<Record<string, boolean>>({
    category: true,
    subcategory: true,
    filterByLetter: true,
    states: true,
    cities: true,
    price: true,
    sorting: true,
  });
  const [sorting, setSorting] = useState<TSortingValue>();
  const [showMenu, setShowMenu] = useState(false);
  const [states, setStates] = useState<IState[]>([]);
  const [cities, setCities] = useState<ICity[]>([]);
  const [priceRange, setPriceRange] = useState<TRange>({ min: 0, max: 0 });
  const [undefinedPrices, setUndefinedPrices] = useState(true);
  const [categorySearch, setCategorySearch] = useState("");
  const [selectedCategories, setSelectedCategories] = useState<IOptions[]>([]);
  const [subcategorySearch, setSubcategorySearch] = useState("");
  const [selectedSubcategories, setSelectedSubcategories] = useState<
    IOptions[]
  >([]);
  const [selectedLetter, setSelectedLetter] = useState<string | null>(null);
  const statesFilter = arrayToString(states);
  const citiesFilter = arrayToString(cities);
  const {
    categoriesError,
    categoriesFilter,
    categoriesOptions,
    categoryByUrl,
  } = useCategories({
    segment: "products",
    search: categorySearch,
    // states: statesFilter,
    // cities: citiesFilter,
    // hideEmpty: true,
    selectedCategories,
  });
  const {
    subCategoriesError,
    subCategoriesFilter,
    subCategoriesOptions,
    subcategoryByUrl,
  } = useSubCategories({
    categories: categoriesFilter,
    search: subcategorySearch,
    states: statesFilter,
    cities: citiesFilter,
    hideEmpty: true,
    selectedSubcategories,
  });
  const categoryTitle = categoryByUrl ? ` - ${categoryByUrl.title}` : "";
  const subcategoryTitle = subcategoryByUrl ? `/${subcategoryByUrl.title}` : "";
  const pageTitle = `Produtos Oficiais${categoryTitle}${subcategoryTitle}`;
  const [windowSize, setWindowSize] = useState<number>(window.innerWidth);
  const [layout, setLayout] = useState({ grid: 0, row, perPage });

  const layoutSetter = (width: number) => {
    if (width < 540) {
      setLayout({ grid: 2, row: 3, perPage: 6 });
    } else if (width < 720) {
      setLayout({ grid: 3, row: 3, perPage: 9 });
    } else if (width < 900) {
      setLayout({ grid: 4, row: 3, perPage: 12 });
    } else if (width < 1024) {
      setLayout({ grid: 5, row: 3, perPage: 15 });
    } else if (width < 1180) {
      setLayout({ grid: 4, row: 3, perPage: 12 });
    } else {
      setLayout({ grid: 5, row: 3, perPage: 15 });
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowSize(width);
      layoutSetter(width);
    };

    layoutSetter(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleHide = (key: string) => {
    setHideStates(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <Styled.Container id="products-list">
      <Helmet>
        <meta name="description" content="Produtos à venda" />
        <link rel="canonical" href="https://rurax.com.br/produtos/" />
      </Helmet>
      <HeaderPageTitle
        link={link}
        //sideChildren={!hideSorting && <Sorting setSorting={setSorting} />}
      >
        {title ? title : pageTitle}
      </HeaderPageTitle>
      {mobile && (
        <Styled.MobileFilterContainer>
          <Styled.ButtonContainer>
            <div>Ordenar</div>
            <Styled.SelectorContainer>
              <Sorting
                newSelect={true}
                setSorting={setSorting}
                width={15}
                mobileMenu
              />
            </Styled.SelectorContainer>
          </Styled.ButtonContainer>
          <Styled.ButtonContainer
            onClick={() => {
              setShowMenu(!showMenu);
            }}
          >
            Filtrar
          </Styled.ButtonContainer>
        </Styled.MobileFilterContainer>
      )}
      <List2
        useData={useProducts}
        dataParams={{
          firstLetter: selectedLetter,
          vehicles: false,
          categories: categoriesFilter,
          subcategories: subCategoriesFilter,
          states: statesFilter,
          cities: citiesFilter,
          price: stringRange(priceRange, setPriceRange),
          undefinedPrices,
          published,
          perPage: layout.perPage,
          sort: sorting && sorting.sort,
          order: sorting && sorting.order,
          userId: userId && userId,
        }}
        displayOn={showMenu}
        setDisplayOn={setShowMenu}
        hideSearch={hideSearch}
        hideFilters={hideFilters}
        hidePagination={hidePagination}
        sorting={sorting}
        inline={inline}
        seeMoreLink={link}
        seeMoreText={`Ver mais ${pageTitle.toLowerCase()}`}
        row={layout.row}
        filters={{
          states: statesFilter,
          cities: citiesFilter,
          price: stringRange(priceRange),
          categories: categoriesFilter,
          subcategories: subCategoriesFilter,
        }}
        grid={layout.grid}
        segment="products"
        ItemLayout={(item: any) => (
          <>
            <AdListItem
              link={Routes.product.replace(":slug", item.slug)}
              slug={item.slug}
              image={item.image_highlight || item.images?.[0]?.image || ""}
              title={item?.title}
              subcategory={
                typeof item.subcategory === "string"
                  ? item.subcategory
                  : (item.subcategory && item.subcategory.title) || ""
              }
              category={
                typeof item.category === "string"
                  ? item.category
                  : (item.category.title && item.category.title) || ""
              }
              tagHighlight={item.isHighlighted}
              price={item.price}
              oldPrice={item.oldPrice}
              stock={item?.stock}
            />
          </>
        )}
      >
        <>
          {!categoryByUrl && (
            <Styledd.Container>
              <Styledd.SearchContainer>
                <Styledd.SearchTitleContainer>
                  <Styledd.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={false}
                    className="filters-title"
                    onClick={() => {}}
                  >
                    Categoria
                  </Styledd.Title>
                  {mobile && (
                    <Styled.Expand onClick={() => toggleHide("category")}>
                      {hideStates["category"] ? (
                        <IoIosArrowDown size={24} />
                      ) : (
                        <IoIosArrowUp size={24} />
                      )}
                    </Styled.Expand>
                  )}
                </Styledd.SearchTitleContainer>
                <Categories
                  hideSearch={hideStates["category"]}
                  categoriesError={categoriesError}
                  categoryOptions={categoriesOptions}
                  categorySearch={categorySearch}
                  selectedCategories={selectedCategories}
                  setCategorySearch={setCategorySearch}
                  setSelectedCategories={setSelectedCategories}
                  segment={{
                    name: "products",
                    subvalue: "produtos",
                  }}
                />
              </Styledd.SearchContainer>
            </Styledd.Container>
          )}

          {!subcategoryByUrl && (
            <Styledd.Container
              style={{
                maxHeight: "228px",
                overflowY: "auto",
              }}
            >
              <Styledd.SearchContainer>
                <Styledd.SearchTitleContainer>
                  <Styledd.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={false}
                    className="filters-title"
                    onClick={() => {}}
                  >
                    Subcategorias
                  </Styledd.Title>

                  {mobile && (
                    <Styled.Expand onClick={() => toggleHide("subcategory")}>
                      {hideStates["subcategory"] ? (
                        <IoIosArrowDown size={24} />
                      ) : (
                        <IoIosArrowUp size={24} />
                      )}
                    </Styled.Expand>
                  )}
                </Styledd.SearchTitleContainer>
                <Subcategories
                  hideSearch={hideStates["subcategory"]}
                  subcategoriesError={subCategoriesError}
                  selectedSubcategories={selectedSubcategories}
                  setSelectedSubcategories={setSelectedSubcategories}
                  subcategoryOptions={subCategoriesOptions}
                  subcategorySearch={subcategorySearch}
                  initialSubCategoryOptions={[]}
                  setSubCategorySearch={setSubcategorySearch}
                  segment={{
                    name: "products",
                    subvalue: "produtos",
                  }}
                />
              </Styledd.SearchContainer>
            </Styledd.Container>
          )}
          {!hideSorting && (
            <Styledd.Container>
              <Styledd.SearchContainer>
                <Styledd.SearchTitleContainer>
                  <Styledd.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={false}
                    className="filters-title"
                    onClick={() => {}}
                  >
                    Filtrar:
                  </Styledd.Title>
                  {mobile && (
                    <Styled.Expand onClick={() => toggleHide("filterByLetter")}>
                      {hideStates["filterByLetter"] ? (
                        <IoIosArrowDown size={24} />
                      ) : (
                        <IoIosArrowUp size={24} />
                      )}
                    </Styled.Expand>
                  )}
                </Styledd.SearchTitleContainer>

                <FilterByLetter
                  hideSearch={hideStates["filterByLetter"]}
                  selected={selectedLetter}
                  setSelected={setSelectedLetter}
                />
              </Styledd.SearchContainer>
            </Styledd.Container>
          )}
          <Styledd.Container>
            <Styledd.SearchContainer>
              <Styledd.SearchTitleContainer>
                <Styledd.Title
                  style={{ color: "#1A1A1A" }}
                  searchHidden={false}
                  className="filters-title"
                  onClick={() => {}}
                >
                  Estados
                </Styledd.Title>
                {mobile && (
                  <Styled.Expand onClick={() => toggleHide("states")}>
                    {hideStates["states"] ? (
                      <IoIosArrowDown size={24} />
                    ) : (
                      <IoIosArrowUp size={24} />
                    )}
                  </Styled.Expand>
                )}
              </Styledd.SearchTitleContainer>
              <States
                hideSearch={hideStates["states"]}
                name="states"
                setValue={setStates}
                label=""
              />
            </Styledd.SearchContainer>
          </Styledd.Container>

          <Styledd.Container
            style={{
              maxHeight: "228px",
              overflowY: "auto",
            }}
          >
            <Styledd.SearchContainer>
              <Styledd.SearchTitleContainer>
                <Styledd.Title
                  style={{ color: "#1A1A1A" }}
                  searchHidden={false}
                  className="filters-title"
                  onClick={() => {}}
                >
                  Cidades
                </Styledd.Title>
                {mobile && (
                  <Styled.Expand onClick={() => toggleHide("cities")}>
                    {hideStates["cities"] ? (
                      <IoIosArrowDown size={24} />
                    ) : (
                      <IoIosArrowUp size={24} />
                    )}
                  </Styled.Expand>
                )}
              </Styledd.SearchTitleContainer>
              <Cities
                hideSearch={hideStates["cities"]}
                name="cities"
                setValue={setCities}
                states={states}
                segment="products"
                hiddenLabel={true}
                categories={categoriesFilter}
                subcategories={subCategoriesFilter}
              />
            </Styledd.SearchContainer>
          </Styledd.Container>

          <Styledd.Container>
            <Styledd.SearchContainer>
              <Styledd.SearchTitleContainer>
                <Styledd.Title
                  style={{ color: "#1A1A1A" }}
                  searchHidden={false}
                  className="filters-title"
                  onClick={() => {}}
                >
                  Preço
                </Styledd.Title>
                {mobile && (
                  <Styled.Expand onClick={() => toggleHide("price")}>
                    {hideStates["price"] ? (
                      <IoIosArrowDown size={24} />
                    ) : (
                      <IoIosArrowUp size={24} />
                    )}
                  </Styled.Expand>
                )}
              </Styledd.SearchTitleContainer>
              <RangeField
                hideSearch={hideStates["price"]}
                title=""
                name="price"
                isCurrency={true}
                change={setPriceRange}
                values={priceRange}
                undefinedValues={undefinedPrices}
                setUndefinedValues={setUndefinedPrices}
                undefinedValuesMessage={"Incluir produtos sem preço"}
              />
            </Styledd.SearchContainer>
          </Styledd.Container>

          {!hideSorting && !mobile && (
            <Styledd.Container style={{ marginBottom: 88 }}>
              <Styledd.SearchContainer>
                <Styledd.SearchTitleContainer>
                  <Styledd.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={false}
                    className="filters-title"
                    onClick={() => {}}
                  >
                    Ordenar por:
                  </Styledd.Title>
                  {mobile && (
                    <Styled.Expand onClick={() => toggleHide("sorting")}>
                      {hideStates["sorting"] ? (
                        <IoIosArrowDown size={24} />
                      ) : (
                        <IoIosArrowUp size={24} />
                      )}
                    </Styled.Expand>
                  )}
                </Styledd.SearchTitleContainer>
                <Sorting
                  hideSearch={hideStates["sorting"]}
                  newSelect={true}
                  setSorting={setSorting}
                />
              </Styledd.SearchContainer>
            </Styledd.Container>
          )}
        </>
      </List2>
      {/* <Related
        userid={user ? user.id : ""}
        segment={segment}
        mobile={mobile}
        excludeId={0}
      /> */}
    </Styled.Container>
  );
};

export default ProductList;
